// extracted by mini-css-extract-plugin
export default {"announcementBarContainer":"AnnouncementBar_announcementBarContainer__fjGIm","message":"AnnouncementBar_message__fVGeP"};